import { gql } from '@apollo/client';
const CHANGE_MODEL_SIZE_STANDARD = gql `
  mutation ChangeModelSizeStandard($modelSpecificationId: ID!, $sizeStandardId: ID!) {
    changeModelSpecificationSizeStandard(
      modelSpecificationId: $modelSpecificationId
      sizeStandardId: $sizeStandardId
    ) {
      modelSpecification {
        id
        sizeStandard {
          id
          name
        }
      }
    }
  }
`;
export default CHANGE_MODEL_SIZE_STANDARD;
